<template>
  <div class="timeline">
    <ul>
      <timeline-element v-for="education in educations.slice().reverse()" :key="education.id" :education="education"></timeline-element>
    </ul>
  </div>
</template>

<script>
import TimelineElement from "./TimelineElement";

export default {
  name: "Timeline",
  components: {TimelineElement},
  computed: {
    educations(){
      return this.$store.getters['about/getEducations'];
    }
  }
}

</script>

<style scoped>
.timeline {
  width: 80%;
  height: auto;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
}
.timeline ul {
  list-style: none;
}
@media (min-width: 768px) {
  .timeline:before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 100%;
    background-color: black;
  }
}
@media (max-width: 767px) {
  ul {
    padding: 0;
  }
}
</style>